// extracted by mini-css-extract-plugin
export default {"emptyContainer":"emptyTable_emptyContainer__gWOaj"};